// Copyright (c) 2022 by Move Closer

import { ModulesUiRegistryEntry } from '../../../contexts'
import { resolveAccordionModuleContent } from '../Accordion.helpers'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (original)
 */
export const accordionModule: ModulesUiRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "ui/core/accordion" */ './Accordion.ui.vue'
  ),
  resolver: resolveAccordionModuleContent
}
